// extracted by mini-css-extract-plugin
module.exports = {"margin_left_20":"EligibilityQuestionFarmTruck_margin_left_20__2A7j3","margin_back":"EligibilityQuestionFarmTruck_margin_back__3rOpP"};